import { placesEnvironment } from '../places-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { placeDetailsSchema } from '../schemas/place-details.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Get the details of a place based on the provided TrimblePlaceId
 * @param placeId The TrimblePlaceId for the place
 * @param attributeSource The attribute source. By default, any custom attributes are returned (if present).
 * If no attributes are customized, Trimble MAPS managed attributes are returned.
 * @returns The place details
 */
export function getPlaceDetails(
  this: unknown,
  request: {
    placeId: string;
    attributeSource?: 'Custom' | 'Trimble';
  }
) {
  const params =
    typeof request.attributeSource === 'undefined'
      ? ''
      : `?${new URLSearchParams([['attributeSource', String(request.attributeSource)]]).toString()}`;

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${placesEnvironment.resolve(this).placesPlacePlaceIdDetailsUrl(request.placeId)}${params}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(placeDetailsSchema));
}
